module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix",
    style: ({
      minHeight: _vm.minHeight + 'px',
      width: '100%'
    }),
    attrs: {
      "id": _vm.outerId
    }
  }, [_c('div', {
    style: ({
      minHeight: _vm.minHeight + 'px',
      width: '100%'
    }),
    attrs: {
      "id": _vm.chartId
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39fcf11a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/SimpleLayeredBar.vue
// module id = 2153
// module chunks = 1